import { FC } from "react";
import "./ApplicationSubmitted.scss";
import { faFileUpload, faHeadset, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PrimaryButton } from "@ucl/library";

export interface ApplicationSubmittedProps {
}

export const ApplicationSubmitted: FC<ApplicationSubmittedProps> = () => {
  const handleAccessPortal = () => {
    window.open("/customer/portal", "_blank");
  };

  return (
    <section className="application-submitted">
      <div className="application-submitted__content">
        <div className="application-submitted__header">
          <h1 className="application-submitted__title">Your application has been submitted!</h1>
        </div>

        <p className="application-submitted__message">
          Thank you for applying — we've received your information and will begin reviewing it
          shortly. You'll hear from us as soon as there's an update.
        </p>

        <div className="application-submitted__portal-section">
          <h2 className="application-submitted__portal-title">
            Want to stay updated? Sign into the application portal to:
          </h2>

          <ul className="application-submitted__benefits-list">
            <li className="application-submitted__benefit-item">
              <FontAwesomeIcon icon={faInfoCircle} />
              <span>Track your application status</span>
            </li>
            <li className="application-submitted__benefit-item">
              <FontAwesomeIcon icon={faFileUpload} />
              <span>Upload any requested documents</span>
            </li>
            <li className="application-submitted__benefit-item">
              <FontAwesomeIcon icon={faHeadset} />
              <span>Get faster support</span>
            </li>
          </ul>

          <PrimaryButton onClick={handleAccessPortal} text="Access Portal" />
        </div>
      </div>
    </section>
  );
};
